// Global components.
import React, { Component } from 'react';
import { Container, Col, Image, Row } from 'react-bootstrap';

// Custom components.
import MainMenu from './MainMenu';

// Assets.
import logo from '../../assets/logo.svg';

// Styles.
import '../../styles/components/global/Header.scss';

class Header extends Component {
  render() {
    return (
      <header className="App__header">
        <Container>
          <Row className="App__header-row">
            <Col className="App__header-logo">
              <Image src={ logo } alt="logo" />
            </Col>
            <Col className="App__header-menu">
              <MainMenu />
            </Col>
          </Row>
        </Container>
      </header>
    );
  }
}

export default Header;
